<script lang="ts" setup>
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline';
import { InputField } from '@vue-interface/input-field';

defineProps<{
    activity?: boolean
}>();

const model = defineModel<string>();
</script>

<template>
    <InputField
        id="search"
        ref="el"
        v-model="model"
        autocomplete="off"
        clearable
        :activity="activity"
        type="text"
        name="search"
        placeholder="Search…">
        <template #icon>
            <MagnifyingGlassIcon class="h-6 w-6" />
        </template>
    </InputField>
</template>